import React, { useEffect } from 'react';
import { Button } from '@els/els-react--button';
import { reactions } from '@Constants';
import { trackSummaryGenerationError } from '@Containers/Summary/analytics';

function SummaryError({ fetchSummary, activeBreadcrumb = {}, params = {} }) {
  const { resultName, databaseId } = params;
  const { quickSearchItem, semanticResultName } = activeBreadcrumb;
  const isReactionSummary = activeBreadcrumb?.context === reactions && activeBreadcrumb?.reactionSummaryEligible;
  const shouldShowRegenerateButton = !isReactionSummary;

  useEffect(() => {
    trackSummaryGenerationError();
  }, []);

  return (
    <div className="ai-search-summary__error" data-testid="summary-error">
      <div className="o-els-flex-layout o-els-flex-layout--center o-els-flex-layout--middle">
        <svg className="ai-search-summary__error-icon o-els-flex-layout__item">
          <use xlinkHref="#icon-summary-error" />
        </svg>
        <p className="ai-search-summary__error-text o-els-flex-layout__item u-els-font-size-body-large">
          We encountered an error while generating the summary.
        </p>
      </div>
      {shouldShowRegenerateButton && (
        <div className="o-els-flex-layout o-els-flex-layout--center u-els-margin-bottom">
          <Button
            type="secondary"
            size="small"
            onClick={() =>
              fetchSummary({
                resultName,
                semanticResultName,
                databaseId,
                query: quickSearchItem?.content,
              })
            }
            data-e2e="regenerate-summary-button"
            className="o-els-flex-layout__item">
            Regenerate summary
          </Button>
        </div>
      )}
    </div>
  );
}

export default SummaryError;
